"use client"

import { type ChangeEvent } from "react"

type Props = {
  yZoom: number
  xZoom: number
  onYZoomChange: (next: number) => void
  onXZoomChange: (next: number) => void
}

const ZoomSlider = ({
  label,
  value,
  onChange,
}: {
  label: string
  value: number
  onChange: (next: number) => void
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    onChange(Number(event.target.value))
  return (
    <label className="flex items-center gap-1">
      <span>{label}</span>
      <input
        type="range"
        min={0}
        max={1}
        step={0.01}
        value={value}
        onChange={handleChange}
        className="h-2 w-20 cursor-pointer"
      />
    </label>
  )
}

export const LossOfControlEditorZoomControls = ({
  yZoom,
  xZoom,
  onYZoomChange,
  onXZoomChange,
}: Props) => {
  return (
    <div
      className="absolute left-0 right-0 top-0 z-10 flex items-center gap-3 px-2 py-0.5 text-[9px] font-mono leading-none pointer-events-none"
    >
      <div className="pointer-events-auto flex items-center gap-3">
        <ZoomSlider label="y zoom" value={yZoom} onChange={onYZoomChange} />
        <ZoomSlider label="x zoom" value={xZoom} onChange={onXZoomChange} />
      </div>
    </div>
  )
}
